export class PaymentDetailModel {
    paymentId: string;
    razorpayOrderId: string;
    razorpaySignature: string;
}